<template lang="html">
  <div>
    <server-item v-model="selectedItemId" />
    <v-card
      v-if="!showItemOnly"
      :key="instanceKey"
    >
      <page-bar
        :title="pageTitle"
        :context-menu="defaultContextMenu"
        :loading="isDataLoading"
      />
      <api-errors :errors="errors" />
      <item-select-table
        :add-action="addNewItem"
        :add-label="'Add ' + type"
        :edit-action="editItem"
        :search="true"
        :items="items.map(i => {
          if (!i.active) return {...i, disabled: true}
          else return i
        })"
        :pagination.sync="pagination"
        :total-items="totalListItems"
        :headers="headers"
      >
        <template #icon="{ item: server }">
          <server-initial-icon 
            v-bind="{server}"
            large
          />
        </template>
        <template
          slot="name"
          slot-scope="props"
        >
          {{ `${props.item.firstName || ''} ${props.item.lastName || ''}` }}
        </template>
        <template
          slot="locations"
          slot-scope="props"
        >
          <div v-if="!(props.item.locations || []).length">
            All Locations
          </div>
          <div v-else>
            <v-chip
              v-for="location in props.item.locations"
              :key="'server-' + props.item.id + '-location-' + location.locationId"
            >
              {{ (locationsMap[location.locationId] || {}).name }}
            </v-chip>
          </div>
        </template>
      </item-select-table>
    </v-card>
  </div>
</template>

<script>
import {itemSelect} from '@/ft-vue-core'
import serverMixins from './mixins/serverMixins'
import ServerItem from './ServerItem'
import ServerInitialIcon from '../../floorPlan/helperComponents/ServerInitialIcon.vue'

var itemDefault = {
  id: null,
  recordLockExpiration: null,
}

export default {
  name: 'ServerList',
  components: {ServerItem, ServerInitialIcon},
  mixins: [itemSelect, serverMixins],
  data: function () {
    return {
      type: 'Server',
      types: 'Servers',
      apiRecordCommand: 'diningServer',
      itemDefault: itemDefault,
      headers: [
        this.headerSlot('Icon', 'icon', false, {'ft-thin-cell': true}),
        this.headerSlot('Name', 'name', true, {}),
        this.headerText('Nickname', 'nickname', false, undefined, {}),
        this.headerText('Max Tables', 'maxTables', true, undefined, {}),
        this.headerText('Max Covers', 'maxCovers', true, undefined, {}),
        this.headerSlot('Locations', 'locations', false, {}),
        this.headerSwitch('Active', 'active', true, {}),
      ],
    }
  },
  computed: {
    locationsMap () {
      return this.locations.reduce((acc, r) => {
        acc[r.id] = r
        return acc
      }, {}) ?? {}
    },
  },
  methods: {
    loadList () {
      this.$ftAPI().get(this.addResourceErrorHandler({
        command: 'diningServer',
        load: this.items,
        loading: this.isLoading,
        params: {
          children: true
        }
      }))
    }
  }
}
</script>